import { cn } from '@/app/utils/cn'
import { DropzoneOptions, useDropzone } from 'react-dropzone'

export interface DropzoneProps {
  onDrop: DropzoneOptions['onDrop']
  value: File[] | null
  dropzoneOptions?: DropzoneOptions
  render: (props: { value: File[] | null }) => JSX.Element
}

export const Dropzone = ({
  onDrop,
  value,
  dropzoneOptions,
  render,
}: DropzoneProps) => {
  const { getRootProps, getInputProps, isDragAccept } = useDropzone({
    onDrop,
    ...dropzoneOptions,
  })

  return (
    <div
      className={cn(
        'w-full cursor-pointer rounded-md border border-dashed p-6 hover:border-primary',
        {
          'border-primary': isDragAccept,
        },
      )}
      {...getRootProps()}
    >
      <div className="w-full">
        <input {...getInputProps()} />
        {render({ value })}
      </div>
    </div>
  )
}
